import { AxiosInstance } from "axios"

import { GetUserFavListResponse } from "./getRecentProperties"
import { GetUserFavListRequest } from "./getSpecificFavoriteListWithId"

export function deleteFavouriteListApi(
  {
    params,
    method = "delete",
    url = `/user/favouritelist/deletefavouritelist/${params.favoriteListId}`,
    ...config
  }: GetUserFavListRequest,
  axiosInstance: AxiosInstance,
): Promise<GetUserFavListResponse> {
  return axiosInstance({
    data: { ...params },
    method,
    url,
    ...config,
  }) as Promise<GetUserFavListResponse>
}
